const usePrefixPath = () => {
    const selectedPath = (locationPathName: string, pathName: string) => {
        return locationPathName.split('/')[1] === pathName.split('/')[1]
    }

    return {
        selectedPath,
    }
}

export default usePrefixPath
